import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { rejectReturn } from "../../api/apiReturns";
import parseError from "../../utils/parseError";

export const useRejectReturn = () => {
    const queryClient = useQueryClient();

    const { mutate: rejectReturnMutate, isPending: isRejecting } = useMutation({
        mutationFn: ({ id, data }) => rejectReturn(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Return rejected");
            queryClient.invalidateQueries(["returns"]);
            queryClient.invalidateQueries(["return"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to reject return");
        },
    });

    return { rejectReturnMutate, isRejecting };
};
